// extracted by mini-css-extract-plugin
export default {"imageWrapper":"aP-z","twoColumnImage":"bP-z"};